<div class="sidecontent-option-container">
  <mat-toolbar class="sidemenu-toolbar">
    <i class="icon mdi mdi-cog"></i>
    <span class="title">Settings</span>
  </mat-toolbar>
  <div class="scroll-container">
  <div class="app-name">
    <h3 class="title">{{applicationData.application_name}}</h3>
    <mat-slide-toggle (change)="onToggleChange($event)" >Edit
    </mat-slide-toggle>
  </div>
  <div class="application-container" [ngStyle]="{'pointer-events': !isChecked ? 'none' : 'auto'}">

    <div class="mat-form-field-container">
      <mat-form-field appearance="outline">
        <mat-label >Name</mat-label>
        <input matInput [(ngModel)]="applicationName"  [readonly]="!isChecked">
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label >Description</mat-label>
        <textarea matInput [(ngModel)]="applicationDescription" maxlength="80" [readonly]="!isChecked"></textarea>
      <mat-hint  class="hint">{{ applicationDescription?.length }}/80 Characters
        Max</mat-hint>
      </mat-form-field>
    </div>
   

    <div class="app-icon-container">
      <div class="hint">App Icon</div>
      <div class="icon-img-container" matRipple (click)="fileInput.click()">
        <input #fileInput type="file"  (change)="onFileSelected($event)"
          style="display: none;">
        <img [src]="timeStampEnabled ? (imageSrc + '?cache=' + lastModifiedDate) : imageSrc"  class="w-100" alt="">
        <div class="edit-icon">
            <mat-icon>edit</mat-icon>
        </div>
      </div>
    </div>
    <div *ngIf="isChecked" class="actions">
      <button class="mt-3" mat-raised-button color="primary" [disabled]="showImageLengthError" (click)="onSaveClick()">Save Changes</button>
    </div>
  </div>
  </div>
</div>